import React, { useState } from 'react';

const styles = {
  wrapper: {
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    height: '100vh', background: '#0f0f23',
  },
  card: {
    background: '#1a1a2e', borderRadius: '12px', padding: '2.5rem',
    width: '100%', maxWidth: '380px', boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
    border: '1px solid #2a2a4a',
  },
  title: {
    fontSize: '1.8rem', fontWeight: '700', textAlign: 'center',
    marginBottom: '0.3rem', color: '#e0e0e0',
  },
  subtitle: {
    textAlign: 'center', color: '#666', marginBottom: '2rem', fontSize: '0.9rem',
  },
  label: { display: 'block', marginBottom: '0.4rem', color: '#999', fontSize: '0.85rem' },
  input: {
    width: '100%', padding: '0.7rem 1rem', background: '#0f0f23',
    border: '1px solid #2a2a4a', borderRadius: '8px', color: '#e0e0e0',
    fontSize: '1rem', outline: 'none', marginBottom: '1.2rem',
  },
  button: {
    width: '100%', padding: '0.8rem', background: '#4f46e5',
    border: 'none', borderRadius: '8px', color: '#fff',
    fontSize: '1rem', fontWeight: '600', cursor: 'pointer',
  },
  error: {
    background: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.4)',
    borderRadius: '8px', padding: '0.7rem 1rem', color: '#f87171',
    marginBottom: '1.2rem', fontSize: '0.9rem',
  },
};

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ username, password }),
      });
      const data = await res.json();
      if (res.ok && data.ok) {
        onLogin(data.username);
      } else {
        setError(data.error || 'Login failed');
      }
    } catch {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <div style={styles.title}>Dashboard</div>
        <div style={styles.subtitle}>Sign in to continue</div>
        <form onSubmit={handleSubmit}>
          {error && <div style={styles.error}>{error}</div>}
          <label style={styles.label}>Username</label>
          <input
            style={styles.input}
            type="text"
            value={username}
            onChange={e => setUsername(e.target.value)}
            autoFocus
            required
          />
          <label style={styles.label}>Password</label>
          <input
            style={styles.input}
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
          <button style={styles.button} type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
